
export const dataTeam = {
  "faculty": [
    {
      "name":"Florian Shkurti",
      "image":"assets/team/florian.webp",
      "description":"robot vision, machine learning, planning and control",
	"website":"http://www.cs.toronto.edu/~florian/",
	"twitter": "https://twitter.com/florian_shkurti",
	"googleScholar": "https://scholar.google.com/citations?user=BDmtLHsAAAAJ&hl=en"
    }
  ],
    "Postdocs":[
    {
      "name":"Mike Gimelfarb",
      "image":"assets/team/mike_gimelfarb_1.webp",
      "description":"reinforcement learning, planning, learning to search",
      "website":"https://mike-gimelfarb.github.io/",
      "linkedIn":"https://ca.linkedin.com/in/michael-gimelfarb-0ba5723b",
      "googleScholar":"https://scholar.google.com/citations?user=1tBgyLYAAAAJ&hl=en",
      "github": "https://github.com/mike-gimelfarb"
    },
    {
      "name":"Miroslav Bogdanovic",
      "image":"assets/team/miroslav_bogdanovic_1.webp",
      "description":"robotics, control, imitation and reinforcement learning. co-supervised by <a href='https://animesh.garg.tech/'>Animesh Garg</a>",
      "website":"https://miroslavbogdanovic.super.site/",
      "linkedIn":"https://de.linkedin.com/in/miroslavbogdanovic",
      "googleScholar":"https://scholar.google.com/citations?user=SAdQhg4AAAAJ&hl=fr",
    },
    {
    "name":"Giseung Park",
    "image":"assets/team/Giseung-Park.webp",
    "description":"reinforcement learning, RL applications",
    "website":"https://sites.google.com/view/giseung-park",
    "googleScholar":"https://scholar.google.com/citations?user=M0n5A0AAAAAJ&hl=en&oi=ao",
  },
  {
    "name":"Adam Heins",
    "image":"assets/team/adam_heins_rvl.webp",
    "description":"robot manipulation, chemistry lab automation. co-supervised by <a href='https://www.matter.toronto.edu/basic-content-page/about-alan'>Alán Aspuru-Guzik</a>",
    "website":"https://adamheins.com/",
    "linkedIn":"https://linkedin.com/in/adamwheins",
    "googleScholar":"https://scholar.google.com/citations?hl=en&user=4G2IkRUAAAAJ",
  },
  ],
  "PhD students":[
    {
      "name":"Qiao Gu",
      "image":"assets/team/qiaogu.webp",
      "website":"https://georgegu1997.github.io/",
      "googleScholar":"https://scholar.google.com/citations?user=MF7ISVAAAAAJ&hl=en",
      "linkedIn":"https://www.linkedin.com/in/qiao-gu/",
      "twitter":"https://x.com/qiaogu1997",
      "description": "3D computer vision, robot learning"
    },
    {
      "name":"Wei-Cheng Tseng",
      "image":"assets/team/weicheng_tseng_1.webp",
      "description":"visual foundation models, robot learning",
      "website":"https://weichengtseng.github.io/",
    },
    {
      "name":"Sepehr Samavi",
      "image":"assets/team/sepehr_samavi_1.webp",
      "description":"safe control, crowd navigation. co-supervised by <a href='https://www.dynsyslab.org/prof-angela-schoellig/'>Angela Schoellig</a>",
      "website":"http://dsl.utias.utoronto.ca/~sep/",
      "googleScholar":"https://scholar.google.ca/citations?user=_j5XWygAAAAJ&hl=en",
    },
    {
      "name":"Quentin Clark",
      "image":"assets/team/quentin.webp",
      "description":"generative models, reinforcement learning",
      "website":"https://qtcc-uoft.github.io",
    },
    {
      "name":"Hossein Goli",
      "image":"assets/team/goli.webp",
      "description":"generative models, reinforcement learning, optimization",
      "website": "https://hgoli02.github.io/",
      "linkedIn": "https://www.linkedin.com/in/hosseingoli/",
      "twitter":"https://x.com/HogoGoli",
        "googleScholar":"https://scholar.google.com/citations?user=M0LAA-oAAAAJ",
    },
    {
      "name":"Yuchi (Allan) Zhao",
      "image":"assets/team/yuchi_allan_zhao_1.webp",
      "description":"robot manipulation, chemistry lab automation. co-supervised by <a href='https://www.matter.toronto.edu/basic-content-page/about-alan'>Alan Aspuru-Guzik</a> and <a href='https://animesh.garg.tech'>Animesh Garg</a>",
      "website": "https://y556zhao.github.io/",
      "linkedIn": "https://www.linkedin.com/in/yuchi-allan-zhao/"
    },
    {
      "name":"Yuanliang (Avery) Ju",
      "image":"assets/team/avery1.webp",
      "description":"robot manipulation, 3D vision",
      "twitter":"https://x.com/averyjuuu0213",
        "googleScholar":"https://scholar.google.com/citations?user=rG90YVAAAAAJ&hl=zh-CN",
    },
    {
      "name":"Brandon (Dun-Ming) Huang",
      "image":"assets/team/brandon-huang.webp",
      "description":"reinforcement learning, long-horizon planning, human-robot interaction, cognitive science",
        "website":"http://bransthre.github.io/",
    },
    {
      "name":"Daniel Hocevar",
      "image":"assets/team/headshot-danielhocevar.webp",
      "description":"computer vision, chemistry lab automation. co-supervised by <a href='https://radisiclab.com/people/'>Milica Radisic</a>",
      "linkedIn":"https://www.linkedin.com/in/danielhocevar/",
      "twitter":"https://x.com/daniel_hocevar",
    },
    {
      "name":"James Ross",
      "image":"assets/team/james_ross.webp",
      "description":"computer vision, adversarial simulation generation",
      "googleScholar":"https://scholar.google.com/citations?user=BYyE10gAAAAJ&hl=en",
      "linkedIn":"https://www.linkedin.com/in/jamesrosstwo/",
    },
    {
      "name":"Zhengyang Liang",
      "image":"assets/team/zhengyang-liang.webp",
      "description":"computer vision, generative models",
      "website":"https://maxleung99.github.io/",
      "twitter":"https://x.com/zyliang99",
      "googleScholar":"https://scholar.google.ca/citations?user=o2CMgkUAAAAJ",
    },
    {
      "name":"Yoonsu Kang",
      "image":"assets/team/yoonsu-kang.webp",
      "description":"computer vision, robot learning",
      "website":"https://yskang05.github.io/",
      "googleScholar":"https://scholar.google.com/citations?user=toSjxOAAAAAJ&hl=en",
    },
  ],

  "MSc students":[
    {
      "name":"Shengxiang (Owen) Sun",
      "image":"assets/team/owensun.webp",
      "description":"robot learning, manipulation",
      "linkedIn": "https://www.linkedin.com/in/shengxiang-sun/",
      "website":"https://owensun2004.github.io/",
      "googleScholar":"https://scholar.google.ca/citations?hl=en&user=4nVa1oIAAAAJ",
    },
    {
      "name":"Kavi Dey",
      "image":"assets/team/kavi-dey.webp",
      "description":"interpretable deep learning, diffusion theory",
      "website":"https://kavidey.com/",
      "linkedIn":"https://www.linkedin.com/in/kavidey/",
      "googleScholar":"https://scholar.google.com/citations?user=7quZjo4AAAAJ&hl=en",
    },
    {
      "name":"Jibran Iqbal Shah",
      "image":"assets/team/jibran_headshot.webp",
	    "description":"trajectory prediction, uncertainty-aware planning",
	    "linkedIn": "https://www.linkedin.com/in/jibran-iqbal-shah/",
      "website":"https://jibby1729.github.io/",
      "googleScholar":"https://scholar.google.com/citations?user=XxKtRlMAAAAJ&hl=en",
    },
  ],

  "Visiting students":[
    {
      "name":"Alina Böhm",
      "image":"assets/team/alina-bohm.webp",
      "description":"world models for manipulation. visiting from <a href='https://www.tu-darmstadt.de/'>TU Darmstadt</a>",
    },
  ],

  "undergraduate students":[
    {
      "name":"Emma Xing",
      "image":"assets/team/emma-xing-headshot.webp",
	    "description":"non-rigid body manipulation, physics simulation for robotics, imitation learning",
	    "linkedIn": "https://www.linkedin.com/in/emmaxing/",
      "website":"https://emma-x1.github.io/",
    },
    {
      "name":"Yubo Wang",
      "image":"assets/team/yubo-wang.webp",
	    "description":"field robotics, navigation, localization, autonomous surface vessels",
	    "linkedIn": "https://www.linkedin.com/in/yubo-wang-yyz/",
      "website":"https://yubowng.github.io/",
    },
    {
      "name":"Liyu (Laura) Tao",
      "image":"assets/team/liyu-tao.webp",
	    "description":"robot manipulation, chemistry lab automation, imitation learning",
	    "linkedIn": "http://www.linkedin.com/in/liyu-tao",
        "website":"https://github.com/laura513",
      "googleScholar":"https://scholar.google.com/citations?user=IlhHMPQAAAAJ&hl=en",
    },
    {
      "name":"Frank Jiang",
      "image":"assets/team/frank-jiang.webp",
	    "description":"non-rigid body manipulation, robot learning",
	    "linkedIn": "https://ca.linkedin.com/in/frank-zhaodong-jiang-04558b261",
        "website":"https://frankzhaodong.github.io/",
      "googleScholar":"https://scholar.google.com/citations?user=ISNrsywAAAAJ&hl=en",
    },
    {
      "name":"Nikhil Thiyagarajan",
      "image":"assets/team/Nikhil-Profile-Picture.webp",
	    "description":"crowd navigation, multi-robot planning",
	    "linkedIn": "https://www.linkedin.com/in/nikhil-thiyagarajan-7800841b4/",
        "website":"https://nthiyag.github.io/resume/",
    },
    {
      "name":"Joshua Choi",
      "image":"assets/team/joshua-choi.webp",
      "description":"offline RL, imitation learning, data curation",
	    "linkedIn": "https://www.linkedin.com/in/joshua-choi-416-uoft/",
        "website":"https://choijoshua.github.io/",
    },
    {
      "name":"Leo Wang",
      "image":"assets/team/leo-wang.webp",
      "description":"robot manipulation",
      "linkedIn":"https://www.linkedin.com/in/leo-wang-09833128a/",
    },
    {
      "name":"Kirill Utyashev",
      "image":"assets/team/kirill-utyashev.webp",
      "description":"reinforcement learning, robot learning",
      "linkedIn":"https://www.linkedin.com/in/kirill-utyashev/",
    },
    {
      "name":"Sheena Qin",
      "image":"assets/team/sheena-qin.webp",
      "description":"vision language action models",
      "linkedIn":"https://www.linkedin.com/in/sheena-qin-537501322/",
    },
    {
      "name":"Natasha Yang",
      "image":"assets/team/natasha-yang.webp",
      "description":"computer vision, robot learning, robot manipulation",
      "linkedIn":"https://www.linkedin.com/in/natasha-yang-64a35a1a5/",
    },
    {
      "name":"Emily Yan",
      "image":"assets/team/emily-yan.webp",
      "description":"computer vision, machine learning, biomedical systems",
      "linkedIn":"https://www.linkedin.com/in/emily-yan-637580302/",
    },
  ],

  "alumni: postdocs":[
    {
      "name":"Qi Chen",
      "image":"assets/team/qi_chen_1.webp",
      "description":"statistical learning theory, transfer learning, meta-learning <div><b>next: Assistant Professor, ML Group, Aalto University \& ELLIS</b></div>",
      "website":"https://livreq.github.io/",
      // "email":"",
      // "linkedIn":"",
      "googleScholar":"https://scholar.google.com/citations?view_op=list_works&hl=en&hl=en&user=MqLoSeoAAAAJ",
      "github": "https://github.com/livreQ"
    },
    {
      "name":"Kourosh Darvish",
      "image":"assets/team/kourosh_darvish_2.webp",
      "description":"robotics, control, task and motion planning, machine learning, chemistry lab automation. co-supervised by <a href='https://animesh.garg.tech/'>Animesh Garg</a>. <div><b>next: Research Scientist, Acceleraction Consortium</b></div>",
      "website":"https://kouroshd.github.io/",
      "linkedIn":"https://it.linkedin.com/in/kouroshdarvish",
      "googleScholar":"https://scholar.google.com/citations?user=FwFFVdIAAAAJ",
    },
  ],

  "alumni: graduate students":[
    {
      "name":"Nathan de Lara",
      "image":"assets/team/nathan.webp",
      "description":"reinforcement learning, optimal control, optimization. <div><b>next: CMU MLD PhD</b></div>",
      "googleScholar":"https://scholar.google.ca/citations?user=-OvkuacAAAAJ&hl=en",
      "linkedIn":"https://www.linkedin.com/in/nathan-d-a00821126/",
      "website":"http://www.delaraanalytics.com",
    },
    {
      "name":"Homanga Bharadhwaj",
      "image":"assets/team/homanga_bharadhwaj_1.webp",
      "description":"reinforcement learning, safe exploration, robotics, recommender systems. co-supervised by <a href='https://animesh.garg.tech/'>Animesh Garg</a>. <div><b>next: CMU CS PhD</b></div>",
      "website":"https://homangab.github.io/",
      "googleScholar":"https://scholar.google.ca/citations?user=wwW4HRQAAAAJ&hl=en",
      "twitter":"https://twitter.com/mangahomanga"
    },
    {
      "name":"Philip Huang",
      "image":"assets/team/philip.webp",
      "description":"continual learning, field robotics, task and motion planning. co-supervised by <a href='http://asrl.utias.utoronto.ca/~tdb/'>Tim Barfoot</a>. <div><b>next: CMU CS PhD</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/philip-yizhou-huang",
      "website":"https://philip-huang.github.io/",
      "googleScholar":"https://scholar.google.com/citations?hl=en&user=YDCsS5EAAAAJ"
    },
    {
      "name":"Andrei Ivanovic",
      "image":"assets/team/andrei_ivanovic_2.webp",
      "description":"trajectory prediction and planning. co-supervised by <a href='https://www.gilitschenski.org/igor/'>Igor Gilitschenski</a>. <div><b>next: Amazon Robotics</b></div>",
  "linkedIn":"https://ca.linkedin.com/in/andrei-ivanovic-438313178",
  "website": "https://aivanovic1.github.io/"
  },
  {
    "name":"Kevin Xie",
    "image":"assets/team/kevin.webp",
    "description":"reinforcement learning, control, 3D vision. co-supervised by <a href='https://www.cs.utoronto.ca/~fidler/'>Sanja Fidler</a>. <div><b>next: Research Scientist, Nvidia</b></div>",
    "website":"https://kevincxie.github.io/",
  },
  {
    "name":"Salar Hosseini",
    "image":"assets/team/salar.webp",
    "description":"computer vision, adversarial scenario generation. <div><b>next: Samsung AI</b></div>",
    "linkedIn":"https://ca.linkedin.com/in/salar-hosseini",
    "website":"https://salarios77.github.io/",
    "googleScholar":"https://scholar.google.ca/citations?user=8OT5mY0AAAAJ&hl=en"
  },
  {
    "name":"Ke Dong",
    "image":"assets/team/ke_dong_1.webp",
    "description":"control theory, mobile manipulation. <div><b>next: Research Scientist, Tencent AI</b></div>",
    "linkedIn":"https://ca.linkedin.com/in/ke-dong-7a33a9171",
  },
  {
    "name":"Yewon Lee",
    "image":"assets/team/yewon_lee_1.webp",
    "description":"task and motion planning <div><b>next: U. of Washington CS PhD</b></div>",
    "website":"https://yewon-lee.github.io/",
  },
  {
    "name":"Yasasa Abeysirigoonawardena",
    "image":"assets/team/yasasa_abeysirigoonawardena_1.webp",
    "description":"adversarial scenario generation, neural rendering. <div><b>next: Research Scientist, Waabi</b></div>",
  "linkedIn":"https://ca.linkedin.com/in/yasasa-abeysirigoonawardena-819229198",
  "website": "https://www.yasasa.me/"
  },
  {
    "name":"Jinbang Huang",
    "image":"assets/team/jinbang_huang_1.webp",
    "description":"task and motion planning, control theory, optimization. co-supervised by <a href='http://stars.utias.utoronto.ca/~jkelly/'>Jonathan Kelly</a>. <div><b>next: Huawei AI, Toronto</b></div>",
    "linkedIn":"https://ca.linkedin.com/in/jinbang-huang-989526170",
  },
  {
    "name":"Anthony Lem",
    "image":"assets/team/anthony_lem_1.webp",
    "description":"human pose detection and prediction. <div><b>next: Epson, Toronto</b></div>",
  },
  {
    "name":"Skylar Hao",
    "image":"assets/team/skylar.webp",
    "description":"sim-to-real transfer, safe learning, statistics, machine learning",
  },
  {
    "name":"Mohamed Khodeir",
    "image":"assets/team/mk.webp",
    "linkedIn":"https://ca.linkedin.com/in/khodeir",
    "description": "learning to plan, task and motion planning. <div><b>next: Robotics Engineer, Waabi</b></div>",
  },
  {
    "name":"Blerim Abdullai",
    "image":"assets/team/blerim_abdullai_1.webp",
    "description":"computer vision, field robotics, stochastic planning <div><b>next: Robotics Engineer, Zeon Systems</b></div>",
    "website":"https://www.cs.toronto.edu/~blerim/",
    "linkedIn":"https://www.linkedin.com/in/blerimabdullai",
      "googleScholar":"https://scholar.google.com/citations?user=wdKWt3gAAAAJ&hl=en",
  },
  ],

  "alumni: research associates \& visitors":[
    {
      "name":"Sehee Kweon",
      "image":"assets/team/sehee_kweon.webp",
      "description":"computer vision, generative models, robot learning. <div><b>visitor: Seoul National University</b></div>",
      "linkedIn":"https://www.linkedin.com/in/sehee-kweon-6a2654172",
      "googleScholar":"https://scholar.google.com/citations?hl=en&user=fw1FdlIAAAAJ",
    },
    {
      "name":"Sebastian Aegidius",
      "image":"assets/team/seb_rvl.webp",
      "description":"robot perception, motion and path planning, RL <div><b>next: PhD student, UTIAS",
      "linkedIn":"https://www.linkedin.com/in/sebastian-aegidius-a7584521a/",
    },
    {
      "name":"Derek Tan",
      "image":"assets/team/derektan_headshot_v3.webp",
      "description":"test-time adaptation, multimodal visual search. <div><b>next: PhD student, National University of Singapore</b></div>",
      "website":"https://derektan95.github.io/",
      "linkedIn":"https://www.linkedin.com/in/derektan95/",
      "googleScholar":"https://scholar.google.com/citations?user=dVvzYaoAAAAJ&hl=en",
    },
    {
      "name":"Melissa Mozifian",
      "image":"assets/team/melissa_mozifian_1.webp",
      "description":"visiting phd student, McGill/MILA. combining imitation and reinforcement learning. <div><b>visitor: MILA, McGill</b></div>",
      "website":"https://melfm.github.io/about.html",
      "googleScholar":"https://scholar.google.com/citations?user=sygJEU0AAAAJ&hl=en",
    },
    {
      "name":"Fabian Damken",
      "image":"assets/team/fabian_damken_1.webp",
      "description":"learning planning heuristics <div><b>next: Mathematics PhD student, U. Twente</b></div>",
      "linkedIn":"https://linkedin.com/in/fdamken",
      "website": "https://fabian.damken.net/",
      "twitter": "https://twitter.com/fabian_damken",
      "googleScholar": "https://scholar.google.com/citations?user=EM-y6hYAAAAJ&hl=en",
    },
  ],

  "alumni: undergraduate students":[
    {
      "name":"Sofia Luo",
      "image":"assets/team/sofia-luo.webp",
      "description":"computer vision, robot learning. <div><b>next: UofT PhD, Toronto Computational Imaging Group</b></div>",
	    "linkedIn": "https://www.linkedin.com/in/sofialuo/",
        "website":"https://sofialuo15.github.io/",
    },
    {
      "name":"Tanmay Patel",
      "image":"assets/team/tanmay-patel.webp",
	    "description":"non-rigid body manipulation, imitation learning. <div><b>next: MIT EECS PhD</b></div>",
	    "linkedIn": "https://www.linkedin.com/in/tanmay-patel-uoft/",
      "googleScholar":"https://scholar.google.com/citations?user=IlhHMPQAAAAJ&hl=en",
    },
    {
      "name":"Andrew Magnuson",
      "image":"assets/team/andrew_headshot.webp",
      "description":"robot learning, manipulation. <div><b>next: CMU MSR</b></div>",
	    "linkedIn": "https://www.linkedin.com/in/andrew-magnuson-03/",
        "website":"https://www.andrewmagnuson.ca/",
        "twitter":"https://x.com/ajwmagnuson",
      "googleScholar":"https://scholar.google.com/citations?hl=en&user=x3L1rLQAAAAJ",
    },
    {
      "name":"Ruiting Chen",
      "image":"assets/team/ruiting_chen_1.webp",
      "description":"physics simulation for robotic tasks, adversarial scenarios generation, mesh optimization <div><b>next: Stanford CS MSc</b></div>",
      "linkedIn": "https://ca.linkedin.com/in/ruiting-chen-a24183216",
      "website":"https://ruiting-chen.github.io",
    },
    {
      "name":"Alex Alexiev",
      "image":"assets/team/alexiev.webp",
      "description":"non-rigid body manipulation <div><b>next: MIT MechEng PhD</b></div>",
      "linkedIn":"https://www.linkedin.com/in/alexander-alexiev-125a78201/",
      "website": "https://alex-alexiev.github.io/",
    },
    {
      "name":"Andrew Zou Li",
      "image":"assets/team/andrew_z_li.webp",
      "description":"task and motion planning, chemistry lab automation <div><b>next: MSc student, CMU</b></div>",
      "website": "https://andrewzl.github.io/",
      "linkedIn": "https://www.linkedin.com/in/andrewzouli/"
    },
    {
      "name":"Maria Chzhen",
      "image":"assets/team/maria_c.webp",
      "description":"perception, implicit occupancy and flow representation.",
      "linkedIn": "https://ca.linkedin.com/in/mariachzhen",
    },


    {
      "name":"Julia Chae",
      "image":"assets/team/julia_chae_1.webp",
      "description":"LiDAR and RGB representation learning <div><b>next: MIT EECS PhD</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/julia-chae",
  "website": "https://juliachae.github.io/",
    },

    {
      "name":"Ben Agro",
      "image":"assets/team/ben_agro.webp",
      "description":"learning to plan, task and motion planning, manipulation. <div><b>next: UofT CS PhD / Waabi</b></div>",
      "website":"https://benagro314.github.io/",
      "twitter":"https://twitter.com/BenAgro4",
    },
    {
      "name":"Yijie Wang",
      "image":"assets/team/yije.webp",
      "description":"constrained motion planning, chemistry lab automation",
      "linkedIn":"https://www.linkedin.com/in/yijie-wang0806/",
    },
    {
      "name":"Garvish Bhutani",
      "image":"assets/team/garvish.webp",
      "description":"robotic crowd navigation",
      "linkedIn":"https://www.linkedin.com/in/garvish-bhutani/",
    },
    {
      "name":"Hamza Dugmag",
      "image":"assets/team/hamza_dugmag_1.webp",
  "description":"field robotics, autonomous boat",
  "website": "https://hamzadugmag.com/"
    },
    {
      "name":"Haozhe Sheng",
      "image":"assets/team/haozhe_sheng_1.webp",
      "description":"<div><b>next: Google</b></div>",
    },
    {
      "name":"Jisu Qian",
      "image":"assets/team/jisu_qian_1.webp",
  "description":"system identification",
  "linkedIn": "https://ca.linkedin.com/in/jisu-qian-85b18921b"
    },

    {
        "name":"Cathlyn Chen",
        "image":"assets/team/cathlyn_chen_1.webp",
        "description":"backwards reachability for nonlinear systems <div><b>next: UofT Neuroscience MSc</b></div>",
        "link":"",
    },
    {
        "name":"Kathy Zhuang",
        "image":"assets/team/kathy_zhuang_1.webp",
  "description":"computer vision for transparent objects. <div><b>next: Berkeley CS MSc</b></div>",
  "linkedIn": "https://ca.linkedin.com/in/yue-kathy-zhuang",
  "website": "https://kathyzhuang.github.io/"
    },
    {
      "name":"Artur Kuramshin",
      "image":"assets/team/artur_kuramshin_1.webp",
      "description":"field robotics, autonomous boat <div><b>next: MILA MSc</b></div>",
      "website":"http://akuramshin.ca",
      "linkedIn":"https://www.linkedin.com/in/artur-kuramshin-4b926616a/",
    },
    {
      "name":"Ruiqi Wang",
      "image":"assets/team/ruiqi_wang_1.webp",
      "description":"adversarial scenario generation. <div><b>next: Stanford CS MSc</b></div>",
      "linkedIn":"https://www.linkedin.com/in/ruiqi-wang-3b970b150/",
    },
    {
      "name":"Jerry Zhu",
      "image":"assets/team/jzhu2.webp",
      "description":"bayesian optimisation, deep learning <div><b>next: U. of Chicago Stats PhD</b></div>",
      "linkedIn": "www.linkedin.com/in/jerryzhu509",
    },
    {
      "name":"Charlotte Zhang",
  "image":"assets/team/charlotte_zhang_1.webp",
  "description":"field robotics, autonomous boat <div><b>next: SFU CS PhD</b></div>",
    },
    {
      "name":"Jason Tang",
      "image":"assets/team/jason_tang_1.webp",
      "description":"continual image classification. <div><b>next: UofT CS MSc</b></div>",
    },
    {
      "name":"Pranit Chawla",
      "image":"assets/team/pranit_chawla_1.webp",
  "description":"LiDAR and RGB representation for imitation learning. <div><b>next: CMU CS MSc</b></div>",
  "website": "https://www.pranitchawla.com/",
  "linkedIn": "https://www.linkedin.com/in/pranit-chawla-503237145/"
    },
    {
      "name":"Cong Wei",
      "image":"assets/team/cong_wei_1.webp",
      "linkedIn":"https://ca.linkedin.com/in/cong-wei-30",
      "description": "video summarization, generative models <div><b>next: Waterloo CS PhD</b></div>",
    },
    {
      "name":"Kamran Ramji",
      "image":"assets/team/kamran_ramji_1.webp",
      "description":"combining imitation and reinforcement learning. <div><b>next: Apple</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/kamran-ramji",
    },
    {
      "name":"Stephen Zhao",
      "image":"assets/team/stephen_zhao_1.webp",
  "description":"multi-agent reinforcement learning. co-supervised by <a href='http://www.cs.toronto.edu/~yangxu/'>Yang Xu</a>. <div><b>next: UofT CS MSc</b></div>",
  "linkedIn": "https://ca.linkedin.com/in/zhaostephen"
    },
    {
      "name":"Dhruv Sharma",
      "image":"assets/team/dhruv_sharma_1.webp",
      "description":"autonomous driving, robotics, computer vision. <div><b>next: Huawei AI, Toronto</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/dhruvsharmauw",
      "website":"https://sharmadhruv.weebly.com/",
    },
    {
      "name":"Sherry Chen",
      "image":"assets/team/sherry_chen_1.webp",
      "description":"video representation learning. <div><b>next: UTIAS MSc</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/sherry-chen-engsci127",
    },
    {
      "name":"Sally Chen",
      "image":"assets/team/sally_chen_1.webp",
      "description":"differentiable rendering for self-driving simulators. <div><b>next: CMU CS MSc</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/chuhan-chen",
    },

    {
      "name":"Chris Agia",
      "image":"assets/team/chris_agia_1.webp",
      "description":"3d vision for autonomous driving. <div><b>next: Stanford CS PhD</b></div>",
      "website":"https://agiachris.github.io/",
      "linkedIn":"https://www.linkedin.com/in/agiachris/",
    },
    {
      "name":"Ali Kuwajerwala",
      "image":"assets/team/ali_kuwajerwala_1.webp",
      "description":"backwards reachability for nonlinear systems. <div><b>next: MILA MSc</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/alikuwajerwala",
    },
    {
      "name":"Jason Liu",
      "image":"assets/team/JasonLiu.webp",
      "description":"reinforcement learning, control, simulation, and manipulation. <div><b>next: CMU RI PhD</b></div>",
      "website":"https://jasonjzliu.com/",
    },

    {
      "name":"Shichen Lu",
      "image":"assets/team/shichen_lu_1.webp",
      "description":"control and reinforcement learning for mobile manipulation. <div><b>next: UTIAS MSc</b",
      "linkedIn":"https://ca.linkedin.com/in/shichen-lu",
    },
    {
      "name":"Siyun Li",
      "image":"assets/team/siyun_li_1.webp",
      "description":"adversarial examples for self-driving simulators. <div><b>next: Stanford CS MSc</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/siyun-li",
    },
    {
      "name":"Yuchen Wu",
      "image":"assets/team/yuchen_wu_1.webp",
      "description":"combining imitation and reinforcement learning. <div><b>next: UTIAS MSc</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/yuchen-wu-a9838a14a",
    },
    {
      "name":"Zidong Weng",
      "image":"assets/team/zidong_weng_1.webp",
      "description":"out-of-distribution detection for image and lidar data. <div><b>next: Intel</b></div>",
      "linkedIn":"https://ca.linkedin.com/in/zidong-weng-232035134",
    },
    {
      "name":"Zihan Wang",
      "image":"assets/team/zihan_wang_1.webp",
      "description":"imitation learning for robotics. <div><b>next: Stanford CS MSc</b></div>",
      "website":"https://avinwangzh.github.io/Personal-Website/",
      "linkedIn":"https://ca.linkedin.com/in/zihan-wang-70aa47ab"
    },
    {
      "name":"Sirui (Ariel) Chen",
      "image":"assets/team/ariel_chen_1.webp",
      "description":"pedestrian trajectory prediction. <div><b>next: Stanford MSc</b></div>",
      "website": "https://github.com/arielchen07",
        "linkedIn": "https://ca.linkedin.com/in/sirui-chen-6492a0232"
    },
    {
      "name":"Kelly Zhu",
      "image":"assets/team/kellyzhu.webp",
      "description":"trajectory prediction, uncertainty-aware planning <div><b>next: UofT CS MSc</b></div>",
      "googleScholar":"https://scholar.google.com/citations?user=4k-1QxAAAAAJ&hl=en&oi=sra",
      "linkedin":"https://www.linkedin.com/in/kellyzhu-ca",
      "website":"https://kellyzoo.github.io",
    },


    {
      "name":"Aditya Saigal",
      "image":"assets/team/profile.webp",
      "linkedIn":"https://ca.linkedin.com/in/aditya-saigal-221207143?trk=pub-pbmap",
      "description":"continual reinforcement learning <div><b>next: Tenstorrent</b></div>",
    },
  ],
}

